import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';
import {environment} from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class AuthGuard  {
	constructor() {
	}

	private redirectToLogin(state: RouterStateSnapshot): false {
		window.location.href = environment.login + '?redirectTo=' + window.location.href.split('#')[0] + '%23' + state.url;
		return false;
	}

	canActivate(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return fetchAuthSession()
			.then((session) => {
				const idToken = session.tokens?.idToken;
				if (!idToken?.toString()) {
					return this.redirectToLogin(state);
				}
				return true;
			})
			.catch(() => this.redirectToLogin(state));
	}

	canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return fetchAuthSession()
			.then((session) => {
				const idToken = session.tokens?.idToken;
				if (!idToken?.toString()) {
					return this.redirectToLogin(state);
				}
				return true;
			})
			.catch(() => this.redirectToLogin(state));
	}
}
